module.exports = {
        srcSet: __webpack_public_path__ + "static/media/deal-400.d61e48e0.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/deal-400.d61e48e0.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/deal-400.d61e48e0.webp",
        toString: function(){return __webpack_public_path__ + "static/media/deal-400.d61e48e0.webp"},
        
        width: 400,
        height: 400
      }